import React from 'react';

import { useHeaderLinks } from '../../context/ExternalLink';

import LoginButton from '../LoginButtonComponent';

import themeShape, { DARK_THEME, LIGHT_THEME } from './shapes/theme.shape';

const HeaderLogin = ({ color, ...rest }) => {
  const headerLinks = useHeaderLinks();

  return (
    <LoginButton
      logoutPath={headerLinks.logout}
      userAreaPath={headerLinks.myRequests}
      searchPreferencePath={headerLinks.searchPreferences}
      myProfilePath={headerLinks.myProfile}
      myReferralsPath={headerLinks.myReferrals}
      myPaymentsPath={headerLinks.myPayments}
      color={color}
      {...rest}
      typeMenu={color === LIGHT_THEME ? 'menu-transparent' : 'menu-white'}
    />
  );
};

HeaderLogin.propTypes = {
  color: themeShape
};

HeaderLogin.defaultProps = {
  color: DARK_THEME
};

export default HeaderLogin;
